import script from "./sf-workflow-status-dropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./sf-workflow-status-dropdown.vue?vue&type=script&lang=ts&setup=true"

import "./sf-workflow-status-dropdown.vue?vue&type=style&index=0&id=322df7f4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-322df7f4"]])

export default __exports__